const CLARITY_CONSENT_KEY = 'clarity_consent_v2';

export const checkClarity = () => (!!window.clarity);

export const trackClarityTag = (key, value) => {
  if (checkClarity()) {
    window.clarity('set', key.toString(), value.toString());
  }
};

export const trackClarityEvent = (value) => {
  if (checkClarity()) {
    window.clarity('event', value.toString());
  }
};

export const trackClarityIdentity = (customerId) => {
  if (!customerId) {
    return;
  }

  // https://learn.microsoft.com/en-us/clarity/setup-and-installation/identify-api
  if (checkClarity()) {
    window.clarity('identify', customerId);
  }
};

/**
 * Sets Clarity consent v2 and stores it in localStorage
 * @param {boolean} force - Force set consent even if already stored
 */
export const setClarityConsent = (force = false) => {
  if (!checkClarity()) {
    return;
  }

  // Check if consent already exists in localStorage
  const storedConsent = localStorage.getItem(CLARITY_CONSENT_KEY);
  if (storedConsent && !force) {
    // Restore consent from localStorage
    try {
      const consent = JSON.parse(storedConsent);
      window.clarity('consentv2', consent);
      return;
    } catch (error) {
      console.error('Error parsing stored Clarity consent:', error);
    }
  }

  // Set consent with default values
  const consent = {
    ad_Storage: 'declined',
    analytics_Storage: 'granted',
  };

  // Store in localStorage
  try {
    localStorage.setItem(CLARITY_CONSENT_KEY, JSON.stringify(consent));
  } catch (error) {
    console.error('Error storing Clarity consent in localStorage:', error);
  }

  // Set consent in Clarity
  window.clarity('consentv2', consent);
};

/**
 * Initializes Clarity consent from localStorage if available
 */
export const initClarityConsent = () => {
  setClarityConsent();
};
